import React, { useState } from "react";
import "./Prescription.css";
import RefillsModal from "./PrescriptionModals/RefillsModal";
import RefillReminderModal from "./PrescriptionModals/RefillReminderModal"; // <-- Import the new modal
import AutoRefillModal from "./PrescriptionModals/AutoRefillModal"; // <-- Import the new modal
const Prescription = () => {
  const [openModal, setOpenModal] = useState(null); // Track which modal is open

  const handleModalClose = () => {
    setOpenModal(null); // Close the currently open modal
  };

  // Example: Existing refill submission for logged-in users
  const handleRefillSubmit = async (data) => {
    console.log("Refill Submission Data:", data);
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/prescriptionsubmission/submit-refills`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    console.log("Response:", response);
    return response;
  };

  // New: Refill reminder submission (no login required)
  const handleRefillReminderSubmit = async (data) => {
    console.log("Refill Reminder Data:", data);
    // Adjust your API endpoint as needed (below is a placeholder)
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/prescriptionsubmission/refill-reminders`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    console.log("Response:", response);
    return response;
  };

  // New: Refill reminder submission (no login required)
  const handleAutofillSubmit = async (data) => {
    console.log("Refill Reminder Data:", data);
    // Adjust your API endpoint as needed (below is a placeholder)
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/prescriptionsubmission/submit-autofill`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    console.log("Response:", response);
    return response;
  };

  return (
    <div className="bg-color">
      <div className="prescription-container">
        {/* Hero Section */}
        <div className="hero-section">
          <h2>Welcome to Thompson Square Pharmacy</h2>
          <p>Managing your prescriptions has never been easier.</p>
          <a href="/contact" className="hero-button">
            Have a question? Contact us
          </a>
        </div>

        {/* Services Section */}
        <div className="services-section">
          <h3>Our Services</h3>
          <div className="services-grid">
            {/* Service Card: Refill Reminders */}
            <div className="service-card">
              <span className="service-icon">⏰</span>
              <h4 className="mt-4">Refill Reminders</h4>
              <p>
                Get timely reminders to refill your prescriptions when it is
                ready.
              </p>
              <button
                className="service-link"
                onClick={() => setOpenModal("refillReminders")}
              >
                Sign Up Now &gt;
              </button>
            </div>
            {/* Service Card: Auto Refill */}
            <div className="service-card">
              <span className="service-icon">⚡</span>
              <h4 className="mt-4">Auto Refill</h4>
              <p>
                Our team will automatically refill your recurring prescriptions
                and notify you when ready.
              </p>
              <button
                className="service-link"
                onClick={() => setOpenModal("autofill")}
              >
                Enroll Now &gt;
              </button>
            </div>
            {/* Service Card: Refill */}
            {/* <div className="service-card">
              <span className="service-icon">🔄</span>
              <h4>Refill</h4>
              <p>
                Refill your existing prescriptions quickly and conveniently.
              </p>
              <button
                className="service-link"
                onClick={() => setOpenModal("refill")}
              >
                Request Refill &gt;
              </button>
            </div> */}
            {/* Service Card: Transfer Prescription */}
            <div className="service-card">
              <span className="service-icon">📦</span>
              <h4 className="mt-4">Transfer Prescription</h4>
              <p>Transfer your prescriptions from another pharmacy to us.</p>
              <a href="/transfers" className="service-link">
                Transfer Now &gt;
              </a>
            </div>
            {/* Service Card: Prescription Renewal */}
            {/* <div className="service-card">
              <span className="service-icon">🔁</span>
              <h4>Prescription Renewal</h4>
              <p>Renew your prescriptions with a few easy steps.</p>
              <button
                className="service-link"
                onClick={() => setOpenModal("renewal")}
              >
                Renew Prescription &gt;
              </button>
            </div> */}
            <div className="service-card">
              <span className="service-icon">🔁</span>
              <h4 className="rr mt-6">Refills & Renewals</h4>
              <p>
                Refill or Renew your existing prescriptions quickly and
                conveniently.
              </p>
              <button
                className="service-link"
                onClick={() => setOpenModal("refill")}
              >
                Refill &gt;
              </button>
            </div>
          </div>
        </div>

        {/* Modals */}
        <RefillsModal
          open={openModal === "refill"}
          onClose={handleModalClose}
          onSubmit={handleRefillSubmit}
        />
        <RefillReminderModal
          open={openModal === "refillReminders"}
          onClose={handleModalClose}
          onSubmit={handleRefillReminderSubmit}
        />
        <AutoRefillModal
          open={openModal === "autofill"}
          onClose={handleModalClose}
          onSubmit={handleAutofillSubmit}
        />
      </div>
    </div>
  );
};

export default Prescription;
